const LoginTypes = {
  'Username-Password-Authentication': 'Nativo',
  'google-oauth2': 'Google',
  'facebook': 'Facebook',
  'apple': 'Apple'
};

export default LoginTypes;